import { useEffect } from "react";
import { siteInfo } from "@/mocks/site";

type SeoOptions = {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: string;
  jsonLd?: object;
};

const base = "https://bpj87u.cn";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function upsertJsonLd(data: object) {
  const el = document.createElement("script");
  el.type = "application/ld+json";
  el.text = JSON.stringify(data);
  el.setAttribute("data-cap-seo", "true");
  document.head.querySelectorAll('script[data-cap-seo="true"]').forEach((n) => n.remove());
  document.head.appendChild(el);
}

export function useSeo(opts: SeoOptions) {
  const {
    title,
    description,
    keywords = "海角爆料,海角爆料最新,海角爆料今日,海角爆料实时,新鲜快讯,实时更新,热门事件,吃瓜追更",
    path = "/",
    type = "website",
    jsonLd,
  } = opts;

  useEffect(() => {
    const fullTitle = title.includes(siteInfo.brand) ? title : `${title} - ${siteInfo.brand}`;
    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index, follow");

    const canonical = `${base}${path}`;
    upsertCanonical(canonical);
    upsertMeta("name", "theme-color", "#b3402c");

    // Open Graph
    upsertMeta("property", "og:site_name", siteInfo.brandFull);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:locale", "zh_CN");

    // Twitter Card
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
  }, [title, description, keywords, path, type]);

  useEffect(() => {
    if (jsonLd) upsertJsonLd(jsonLd);
    return () => {
      document.head.querySelectorAll('script[data-cap-seo="true"]').forEach((n) => n.remove());
    };
  }, [jsonLd]);
}